const translation = {
    common: {
        save: "Зберегти"
    },
    profile: {
        title: "Мій профіль",
        cta: {
            profile: "Керувати моїм аккаунтом",
            consents: "Керувати моїми згодами",
            reservations: "Керувати моїми резерваціями"
        },
        reservation: {
            current: "Поточна",
            checkin: "Заселення",
            checkout: "Виселення",
            empty: "Немає резервацій"
        },
        manage: {
            profile: {},
            consents: {
                title: "Мої згоди"
            },
            reservations: {}
        }
    }
};

export default translation;
